import * as crossWindowEvents from "Shared/cross-window-events";
import deepmerge from "deepmerge";
import * as server from "Shared/server";
import { pathCombine } from "Shared/url";
import { checkoutPageUrl } from "Shared/known-urls";
import { CART_LOAD, rejectInvalidQuantity } from "../Cart/action-creators";
import { PAGE_UPDATE, PAGE_UPDATE_SUCCESS, PAGE_UPDATE_FAILURE, } from "SiteLayout/CurrentPage/action-creators";
import { CART_LOAD_SUCCESS, CART_LOAD_FAILURE, CART_OPTIMISTIC_UPDATE, CART_CHANGES_ACCEPTED, isValidQuantity, getExistingItem, } from "../Cart/action-creators";
import { scrollPosition } from "SiteLayout/Root";
import currentPageIsCheckout from "./Pages/Checkout/current-page-is-checkout";
import { setFeedback } from "SiteLayout/GenericFeedbackBar/action-creators";
import { translate } from "Shared/translate";
import { batchActions } from "redux-batched-actions";
import { updateAppShellData } from "../AppShell/action-creators";
import { addEcommerceEventToDataLayer } from "./../TrackingInformation";
import { epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import { replaceState } from "Shared/history";
export const COMPLETE_PURCHASE = "COMPLETE_PURCHASE";
export const COMPLETE_PURCHASE_WITHOUT_PAYMENT_GATEWAY_SUCCESS = "COMPLETE_PURCHASE_WITHOUT_PAYMENT_GATEWAY_SUCCESS";
export const COMPLETE_PURCHASE_FAILURE = "COMPLETE_PURCHASE_FAILURE";
export const CHECKOUT_OPTIMISTIC_UPDATE = "CHECKOUT_OPTIMISTIC_UPDATE";
export const CHECKOUT_CHANGES_ACCEPTED = "CHECKOUT_CHANGES_ACCEPTED";
export const CHECKOUT_CLEARCART = "CHECKOUT_CLEARCART";
export const CHECKOUT_UPDATE_SUCCESS = "CHECKOUT_UPDATE_SUCCESS";
export const TOGGLE_COMPLETE_PURCHASE_MODAL = "TOGGLE_COMPLETE_PURCHASE_MODAL";
let completePurchaseInProgress = false;
export function toggleCompletePurchaseModal(showCompletePurchaseModal) {
    return {
        type: TOGGLE_COMPLETE_PURCHASE_MODAL,
        showCompletePurchaseModal,
    };
}
export function getPreviousQuantity(item) {
    if (!item)
        return 0;
    if (item.quantity > 0 && item.subDeliveries.length < 1)
        return item.quantity;
    if (item.subDeliveries && item.subDeliveries.length > 0)
        return (item.subDeliveries.reduce((n, { quantity }) => n + quantity, 0) +
            item.quantity);
    return 0;
}
export function updateCartItemQuantity(code, quantity, date, unitShortName, location, ticket = null, hasAddedEmvInCart = false, ga4TrackingContext) {
    return (dispatch, getState) => {
        if (!isValidQuantity(quantity)) {
            rejectInvalidQuantity(code);
            return Promise.reject(null);
        }
        const cart = getState().checkout.cart;
        const existingItem = getExistingItem(cart, code);
        const isUpdateAction = existingItem ? true : false;
        const previousQuantity = getPreviousQuantity(existingItem);
        return dispatch(updateCheckoutStateAndSend({
            cart: {
                items: {
                    [code]: {
                        isUpdateAction,
                        newQuantity: quantity,
                        previousQuantity,
                        newUnitShortName: unitShortName,
                        previousUnitShortName: unitShortName,
                        deliveryDate: date,
                    },
                },
                ga4TrackingContext,
            },
        }, location, ticket, hasAddedEmvInCart)).catch((e) => {
            const feedbackText = getActionBarError(translate("/Cart/Errors/ChangeQuantity"), cart, code);
            dispatch(setFeedback({ type: "error", text: feedbackText }));
        });
    };
}
export function getProductDetails(url) {
    return (dispatch, getState) => {
        return server
            .getJson(url)
            .then((r) => {
            return Promise.resolve(r);
        })
            .catch((e) => {
            console.error(e);
            return Promise.reject(null);
        });
    };
}
export function addEmvItemToCart(code, unitShortName, location, quantity, hasAddedEmvInCart = true, ticket = null, date = null) {
    return (dispatch, getState) => {
        return dispatch(updateCartItemQuantity(code, quantity, date, unitShortName, location, ticket, hasAddedEmvInCart))
            .then(() => {
            dispatch(setFeedback({
                type: "success",
                text: translate("/Cart/Emv/EmvItemAddedSuccess"),
            }));
            Promise.resolve();
        })
            .catch(() => {
            dispatch(setFeedback({
                type: "error",
                text: translate("/Cart/Emv/EmvItemAddedError"),
            }));
            Promise.reject();
        });
    };
}
export function updateCartItemUnit(items, location, ticket = null) {
    return (dispatch, getState) => {
        return dispatch(updateCheckoutStateAndSend({
            cart: {
                items: items,
            },
        }, location, ticket)).catch((e) => {
            dispatch(setFeedback({
                type: "error",
                text: translate("/Cart/Errors/ChangeUnit"),
            }));
        });
    };
}
export function updateCartDeliveryDate(code, date, location, ticket = null) {
    return updateCheckoutStateAndSend({
        cart: {
            items: { [code]: { isUpdateAction: true, deliveryDate: date } },
        },
    }, location, ticket);
}
export function toggleIgnoreAvailability(code) {
    return (dispatch, getState) => {
        const cart = getState().checkout.cart;
        const existingItem = getExistingItem(cart, code);
        const subDeliveryDate = existingItem.subDeliveries
            .map((i) => i.date)
            .shift();
        return dispatch(updateCheckoutStateAndSend({
            cart: {
                items: {
                    [code]: {
                        isUpdateAction: true,
                        deliveryDate: subDeliveryDate,
                        newIgnoreAvailability: !existingItem.ignoreAvailability,
                        previousIgnoreAvailability: existingItem.ignoreAvailability,
                    },
                },
            },
        }, "CheckoutPage")).catch((e) => {
            const feedbackText = getActionBarError(translate("/Checkout/SetIgnoreAvailabilityError"), cart, code);
            dispatch(setFeedback({ type: "error", text: feedbackText }));
        });
    };
}
export function toggleProductSample(code) {
    return (dispatch, getState) => {
        const cart = getState().checkout.cart;
        const existingItem = getExistingItem(cart, code);
        return dispatch(updateCheckoutStateAndSend({
            cart: {
                items: {
                    [code]: {
                        isUpdateAction: true,
                        newIsProductSample: !existingItem.isProductSample,
                        previousIsProductSample: existingItem.isProductSample,
                        newDiscountType: existingItem.discountType,
                        newDiscountValue: 0,
                    },
                },
            },
        }, "CheckoutPage")).catch((e) => {
            const feedbackText = getActionBarError(translate("/Checkout/SetProductSampleError"), cart, code);
            dispatch(setFeedback({ type: "error", text: feedbackText }));
        });
    };
}
export function setDiscountValue(code, value) {
    return (dispatch, getState) => {
        const cart = getState().checkout.cart;
        const existingItem = getExistingItem(cart, code);
        dispatch(updateCheckoutState({
            cart: {
                items: {
                    [code]: {
                        isUpdateAction: true,
                        newDiscountValue: value,
                        previousDiscountValue: existingItem.discountValue,
                        newDiscountType: existingItem.discountType,
                    },
                },
            },
        }, "CheckoutPage"));
        return () => flushCheckoutRequests(dispatch, getState).catch((e) => {
            const feedbackText = getActionBarError(translate("/Checkout/SetDiscountError"), cart, code);
            dispatch(setFeedback({ type: "error", text: feedbackText }));
        });
    };
}
export function setDiscountType(code, type) {
    return (dispatch, getState) => {
        const cart = getState().checkout.cart;
        const existingItem = getExistingItem(cart, code);
        return dispatch(updateCheckoutStateAndSend({
            cart: {
                items: {
                    [code]: {
                        isUpdateAction: true,
                        newDiscountType: type,
                        previousDiscountType: existingItem.discountType,
                    },
                },
            },
        }, "CheckoutPage")).catch((e) => {
            const feedbackText = getActionBarError(translate("/Checkout/SetDiscountTypeError"), cart, code);
            dispatch(setFeedback({ type: "error", text: feedbackText }));
        });
    };
}
export function removeCartItem(code, date, unitShortName, location, previousQuantity) {
    return (dispatch, getState) => {
        return dispatch(updateCheckoutStateAndSend({
            cart: {
                items: {
                    [code]: {
                        newQuantity: 0,
                        newUnitShortName: unitShortName,
                        deliveryDate: date,
                        deleteRowOverride: true,
                        previousQuantity: previousQuantity,
                    },
                },
            },
        }, location)).catch((e) => {
            const cart = getState().checkout.cart;
            const feedbackText = getActionBarError(translate("/Cart/Errors/Remove"), cart, code);
            dispatch(setFeedback({ type: "error", text: feedbackText }));
        });
    };
}
export function removeAllCartItems(location) {
    const url = {
        path: pathCombine(checkoutPageUrl().url, "ClearCart"),
    };
    return (dispatch, getState) => {
        return server
            .postJson(url, location, null)
            .then((result) => {
            if (result.trackingData && result.trackingData.ga4EventObjects) {
                let ga4Events = result.trackingData.ga4EventObjects;
                if ("remove_from_cart" in ga4Events) {
                    addEcommerceEventToDataLayer(ga4Events["remove_from_cart"]);
                }
            }
            dispatch(batchActions([
                { type: CHECKOUT_CLEARCART },
                { type: CART_LOAD_SUCCESS, cart: { items: [] } },
            ]));
            return result;
        });
    };
}
function dispatchCartAndCheckoutUpdate(data, getState, emitModified = true) {
    if (emitModified) {
        crossWindowEvents.emit("cart-modified");
    }
    let cartLoadSuccess = () => ({
        type: CART_LOAD_SUCCESS,
        cart: data.cart,
    });
    const checkoutUpdate = () => dispatchCheckoutUpdate(data, getState, emitModified);
    return [cartLoadSuccess(), checkoutUpdate()];
}
function dispatchCheckoutUpdate(data, getState, emitModified = true) {
    if (emitModified) {
        crossWindowEvents.emit("checkout-modified");
    }
    // We only update the page if the user didn't navigate away from the page
    // during the request
    if (currentPageIsCheckout(getState().currentPage)) {
        return {
            page: data,
            type: PAGE_UPDATE_SUCCESS,
        };
    }
    else {
        return {
            type: CHECKOUT_UPDATE_SUCCESS,
            page: data,
        };
    }
}
export function loadCheckout() {
    crossWindowEvents.emit("checkout-modified");
    return {
        type: PAGE_UPDATE,
    };
}
export function setOrderNoteDetails(cart) {
    return updateCheckoutStateAndSend({ cart });
}
let currentCheckoutUpdate = Promise.resolve(null);
crossWindowEvents.on(["checkout-modified", "cart-modified"], (store) => {
    if (!currentPageIsCheckout(store.getState().currentPage)) {
        return;
    }
    store.dispatch(batchActions([
        { type: CART_LOAD },
        { type: PAGE_UPDATE },
    ]));
    console.debug("Reloading checkout since it was modified in another window/tab");
    // Note that we don't update the cart here. That is handled in the action creators for the cart.
    const url = { path: checkoutPageUrl() };
    currentCheckoutUpdate = currentCheckoutUpdate.then(() => {
        server
            .get(url.path.url)
            .then((r) => r.json())
            .then((json) => {
            store.dispatch(dispatchCheckoutUpdate(json, store.getState, false));
        })
            .catch((e) => {
            console.error(e);
            store.dispatch({
                type: CART_LOAD_FAILURE,
                error: e,
                url,
            });
            store.dispatch({
                type: PAGE_UPDATE_FAILURE,
                error: e,
                url,
            });
        });
    });
});
let pendingTickets = [];
function handleCheckoutDiff(dispatch, getState, diff, location = null, ticket = null) {
    if (ticket) {
        pendingTickets.push(ticket);
    }
    diff.id = Math.random();
    if (diff.cart && diff.cart.items) {
        Object.keys(diff.cart.items).forEach((code) => {
            const existingCartItem = getState().checkout.cart.items.find((i) => i.lineItem.code === code);
            const existingItem = existingCartItem && existingCartItem.lineItem;
            const applyIfDefinedOrFallback = (value, fallback) => value !== undefined ? value : fallback;
            if (existingItem) {
                const itemDiff = diff.cart.items[code];
                itemDiff.newQuantity = applyIfDefinedOrFallback(itemDiff.newQuantity, existingItem.quantity);
                itemDiff.previousQuantity = applyIfDefinedOrFallback(itemDiff.previousQuantity, existingItem.quantity);
                itemDiff.rowNumber = applyIfDefinedOrFallback(itemDiff.rowNumber, existingItem.rowNumber);
                itemDiff.previousDiscountType = applyIfDefinedOrFallback(itemDiff.previousDiscountType, existingItem.discountType);
                itemDiff.previousDiscountValue = applyIfDefinedOrFallback(itemDiff.previousDiscountValue, existingItem.discountValue);
                itemDiff.previousIsProductSample = applyIfDefinedOrFallback(itemDiff.previousIsProductSample, existingItem.isProductSample);
                itemDiff.previousIgnoreAvailability = applyIfDefinedOrFallback(itemDiff.previousIgnoreAvailability, existingItem.ignoreAvailability);
            }
        });
    }
    if (completePurchaseInProgress) {
        return Promise.reject(null);
    }
    const actions = [{ type: PAGE_UPDATE }];
    if (diff.cart) {
        const cartDiff = {
            id: Math.random(),
            items: diff.cart.items,
            orderNoteMarking: diff.cart.orderNoteMarking,
            orderNoteOrderNo: diff.cart.orderNoteOrderNo,
            location: location,
            ga4TrackingContext: diff.cart.ga4TrackingContext,
        };
        diff.cart = cartDiff;
        actions.push({ type: CART_LOAD });
        actions.push({
            type: CART_OPTIMISTIC_UPDATE,
            diff: cartDiff,
        });
    }
    actions.push({
        type: CHECKOUT_OPTIMISTIC_UPDATE,
        diff,
    });
    dispatch(batchActions(actions));
}
function updateCheckoutStateAndSend(diff, location = null, ticket = null, hasAddedEmvInCart = false) {
    return (dispatch, getState) => {
        handleCheckoutDiff(dispatch, getState, diff, location, ticket);
        return flushCheckoutRequests(dispatch, getState, location, hasAddedEmvInCart);
    };
}
function updateCheckoutState(diff, location = null, ticket = null) {
    return (dispatch, getState) => {
        return handleCheckoutDiff(dispatch, getState, diff, location, ticket);
    };
}
export function sendPendingCheckoutRequests() {
    return (dispatch, getState) => {
        return flushCheckoutRequests(dispatch, getState, null);
    };
}
function flushCheckoutRequests(dispatch, getState, location = "CheckoutPage", hasAddedEmvInCart = false) {
    const url = {
        path: pathCombine(checkoutPageUrl().url, "update"),
    };
    const sendNextRequest = (failedAttempts = 0) => {
        const state = getState().checkout;
        const currentPendingChanges = state.pendingChanges || [];
        if (!currentPendingChanges.length) {
            return Promise.resolve(state.updateResult);
        }
        let totalDiff = {};
        currentPendingChanges.forEach((r) => (totalDiff = deepmerge(totalDiff, r)));
        let headers;
        if (pendingTickets.length) {
            const tickets = pendingTickets.join(",");
            pendingTickets = [];
            headers = {
                [server.ESALES_TICKET_HEADER]: tickets,
                [server.ESALES_ACTION_HEADER]: server.ESALES_ADD_TO_CART_ACTION,
            };
        }
        return server
            .post(url, Object.assign(Object.assign({}, totalDiff), { hasAddedEmvInCart }), headers)
            .then((r) => r.json())
            .then((json) => {
            if (json.trackingData && json.trackingData.ga4EventObjects) {
                let ga4Events = json.trackingData.ga4EventObjects;
                if ("add_to_cart" in ga4Events) {
                    addEcommerceEventToDataLayer(ga4Events["add_to_cart"]);
                }
                if ("remove_from_cart" in ga4Events) {
                    addEcommerceEventToDataLayer(ga4Events["remove_from_cart"]);
                }
            }
            dispatch(batchActions([
                {
                    type: CART_CHANGES_ACCEPTED,
                    changes: currentPendingChanges
                        .filter((c) => c.cart != null)
                        .map((c) => c.cart),
                },
                {
                    type: CHECKOUT_CHANGES_ACCEPTED,
                    changes: currentPendingChanges,
                },
                ...dispatchCartAndCheckoutUpdate(json, getState),
            ].filter(Boolean)));
            return json.updateResult;
        })
            .catch((e) => {
            console.error("Failed checkout request number: ", failedAttempts);
            if (failedAttempts === 3) {
                dispatch(batchActions([
                    {
                        type: CART_LOAD_FAILURE,
                        error: e,
                        url,
                    },
                    {
                        type: PAGE_UPDATE_FAILURE,
                        error: e,
                        url,
                    },
                ]));
                return Promise.reject(e);
            }
            return sendNextRequest(failedAttempts + 1);
        });
    };
    const sendNextDebounced = () => timeoutPromise(sendNextRequest, 0);
    currentCheckoutUpdate = currentCheckoutUpdate.then(sendNextDebounced, sendNextDebounced);
    return currentCheckoutUpdate;
}
export function completePurchase(model, isStoreDevice, hasAddedEmvInCart = false) {
    return (dispatch, getState) => {
        if (completePurchaseInProgress) {
            return Promise.reject({
                errorMessage: "Complete purchase already in progress",
            });
        }
        dispatch({
            type: COMPLETE_PURCHASE,
        });
        completePurchaseInProgress = true;
        return currentCheckoutUpdate.then(() => {
            return server
                .post(pathCombine(checkoutPageUrl().url, "completePurchase") + "?hasAddedEmvInCart=" + hasAddedEmvInCart, model)
                .then((r) => r.json())
                .then((json) => {
                dispatch(updateAppShellData());
                if (!!json.newPageData) {
                    const completeCheckoutFailure = () => ({
                        type: COMPLETE_PURCHASE_FAILURE,
                    });
                    const cartAndCheckout = dispatchCartAndCheckoutUpdate(json.newPageData, getState);
                    const checkoutFailure = json.newPageData.verifyOrderErrorResultViewModel === null &&
                        completeCheckoutFailure();
                    const batchedArray = [
                        checkoutFailure,
                        ...cartAndCheckout,
                        updateAppShellData(),
                    ];
                    dispatch(batchActions(batchedArray));
                    completePurchaseInProgress = false;
                    if (json.newDeliveryDate !== null) {
                        return Promise.resolve(json.newDeliveryDate);
                    }
                    else if (json.newPageData.verifyOrderErrorResultViewModel.length === 0) {
                        return Promise.reject(null);
                    }
                    else {
                        // Return data with the resolve so modal with changes is shown
                        const obj = {
                            verifyOrderErrorResultViewModel: json.newPageData.verifyOrderErrorResultViewModel,
                        };
                        return Promise.resolve(obj);
                    }
                }
                else if (json.punchOutRedirectUrl) {
                    window.location.href = json.punchOutRedirectUrl;
                    return new Promise(() => null);
                }
                else if (!!json.paymentRedirectUrl) {
                    dispatch(updateAppShellData());
                    // We don't set `completePurchaseInProgress` to false here because
                    // we don't know how long time it takes for the payment gateway
                    // to load and we don't want to allow you to complete the purchase
                    // again during that time.
                    window.location.href = json.paymentRedirectUrl;
                    return new Promise(() => null);
                }
                else if (!!json.orderConfirmationRedirectUrl) {
                    dispatch(updateAppShellData());
                    scrollPosition(0);
                    return replaceState(json.orderConfirmationRedirectUrl)
                        .then(() => {
                        completePurchaseInProgress = false;
                        dispatch({
                            type: COMPLETE_PURCHASE_WITHOUT_PAYMENT_GATEWAY_SUCCESS,
                        });
                    })
                        .catch((e) => {
                        console.error("failed to push confirmation url", e);
                        dispatch({
                            type: COMPLETE_PURCHASE_FAILURE,
                        });
                        completePurchaseInProgress = false;
                        return Promise.reject({ errorMessage: e.message });
                    });
                }
                else {
                    console.error("completePurchase returned unknown result", json);
                    dispatch({
                        type: COMPLETE_PURCHASE_FAILURE,
                    });
                    completePurchaseInProgress = false;
                    return Promise.reject(null);
                }
            })
                .catch((e) => {
                console.error("completePurchase returned error", e);
                dispatch({
                    type: COMPLETE_PURCHASE_FAILURE,
                });
                completePurchaseInProgress = false;
                return Promise.reject({ errorMessage: e.message });
            });
        });
    };
}
function timeoutPromise(func, timer) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            func().then(resolve, reject);
        }, timer);
    });
}
function getActionBarError(message, cart, code) {
    const existingCartItem = cart.items.find((i) => i.lineItem.code === code);
    if (existingCartItem) {
        const codeNbr = epiPropertyValue(existingCartItem.product.content.code);
        return `${message} - ${codeNbr} ${existingCartItem.lineItem.displayName}`;
    }
    return message;
}
